import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'underscorecase'})
export class UnderscorecasePipe implements PipeTransform {
  transform(value: string): string {
    if (value) {
      value = value.trim().toLowerCase().replace(/ /g, "_"); 
    } else {
      value = '';
    }
    return value;
  }
}


// WEBPACK FOOTER //
// ./src/app/custom/underscorecase.pipe.ts